import { useMemo } from 'react';
import debounce from 'lodash/debounce';

const useDebounce = (cb, timeout) => useMemo(() => debounce(cb, timeout), [cb, timeout]);

export default useDebounce;
